module.exports = __webpack_public_path__ + "static/media/ic_categories_game.ab1abcca.svg";